import { useTranslation } from "react-i18next";
import { useAppSelector, useAppDispatch } from "../app/hooks";
import { selectUserProfile } from "../features/authentication/authenticationSlice";
import {
  selectCurrentRegionalCode,
  selectAvailableVariants,
  changeLanguage,
} from "../features/localization/localizationSlice";
import { REGIONAL_VARIANTS } from "../features/localization/utils/regionalDetection";
import { useTheme } from "../features/theme/useTheme";
import ThemeToggle from "../components/ToggleSwitch";
import LeftMenu from "../components/LeftMenu";
import Breadcrumbs from "../components/Breadcrumbs";

const SettingsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const userProfile = useAppSelector(selectUserProfile);
  const currentRegionalCode = useAppSelector(selectCurrentRegionalCode);
  const availableVariants = useAppSelector(selectAvailableVariants);
  const { themeMode, changeTheme } = useTheme();

  const handleLanguageChange = (variantCode: string) => {
    dispatch(changeLanguage(variantCode));
  };

  return (
    <div className="flex h-full gap-4">
      <LeftMenu />
      <div className="w-full p-4 pb-10 lg:px-10">
        <div className="lg:max-w-[694px]">
          <Breadcrumbs />
          <div className="space-y-6 py-6">
            <h1>{t("settings.title")}</h1>

            {/* User Info */}
            <div className="space-y-1">
              <h2 className="text-lg font-semibold">{t("settings.account")}</h2>
              <p className="text-sm text-grey-50 dark:text-grey-70">
                {userProfile?.name}
              </p>
              <p className="text-sm text-grey-50 dark:text-grey-70">
                {userProfile?.emailaddress}
              </p>
            </div>

            {/* Theme */}
            <div>
              <ThemeToggle mode={themeMode} onChange={changeTheme} />
            </div>

            {/* Language */}
            <div className="space-y-2">
              <div className="text-grey-30 dark:text-grey-70 px-2 text-xs font-semibold uppercase">
                {t("settings.language")}
              </div>
              <div className="space-y-1">
                {availableVariants.map((variantCode) => {
                  const variant = REGIONAL_VARIANTS[variantCode];
                  if (!variant) return null;
                  const isActive = currentRegionalCode === variantCode;
                  return (
                    <button
                      key={variantCode}
                      type="button"
                      onClick={() => handleLanguageChange(variantCode)}
                      className={`menu-link w-full ${isActive ? "active" : ""}`}
                    >
                      {variant.nativeName}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
